import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MapComponent } from 'src/app/shared/components/map/map.component';
import { FormLayoutComponent } from '../../shared/components/form-layout/form-layout.component';

import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { CommentService } from 'src/app/features/comment/comment.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { ToastrNotificationService } from 'src/app/shared/services/toastr-notification.service';
import { LookupsDTO } from 'src/app/shared/types/LookupsDTO';
import { ToastrType } from 'src/app/shared/types/ToastrType.enum';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ResponseRequestType, StakeholderSupportType } from './types/PublicCommentDTO';
import { PublicQuestion } from './types/PublicQuestion';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioButton } from '@angular/material/radio';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatSliderModule } from '@angular/material/slider';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { GlobalSearchStakeholderComponent } from 'src/app/shared/components/global-search-stakeholder/global-search-stakeholder.component';
import { GlobalEditStakeholderComponent } from 'src/app/shared/components/global-edit-stakeholder/global-edit-stakeholder.component';
import { MinProjectDTO } from '../subscription/types/MinProjectDTO';
import { UrlParamsService } from '../../shared/services/url-params.service';
import { SubscriptionService } from '../subscription/subscription.service';
import { PublicMapItemDTO } from 'src/app/shared/types/PublicMapItemDTO';
import { GlobalCommentComponent } from 'src/app/shared/components/global-comment/global-comment.component';
import { Router } from '@angular/router';
import { PublicMeetingDTO } from './types/PublicMeetingDTO';
import { MatIconModule } from '@angular/material/icon';
import { Title } from '@angular/platform-browser';
import { SanitizedHtmlComponent } from 'src/app/shared/components/sanitized-html/sanitized-html.component';
import { GTranslateWidgetService } from 'src/app/shared/services/gtranslate-widget.service';

@Component({
  selector: 'app-comment',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    FormLayoutComponent,
    MatChipsModule,
    MatSliderModule,
    NgxSliderModule,
    GlobalCommentComponent,
    MatIconModule,
    SanitizedHtmlComponent,
  ],
  templateUrl: './comment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './comment.component.scss',
})
export class CommentComponent {
  currentUrl: string = '';
  projectInfo: MinProjectDTO | null = null;
  selectedProjectGuid: string = '';
  selectedCommentGuid: string = '';
  meetingGuid: string = '';
  subscribeSourceId!: number;
  isSubmitted: boolean = false;
  isCommentActive: boolean = true;
  closedMessage: string | null = null;

  constructor(
    private urlParamsService: UrlParamsService,
    private commentService: CommentService,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private titleService: Title,
    private gTranslateService: GTranslateWidgetService
  ) {}
  ngOnInit(): void {
    // this.selectedProjectGuid = this.urlParamsService.projectGuid!;
    // this.selectedCommentGuid = this.urlParamsService.commentGuid!;
    // this.meetingGuid = this.urlParamsService.meetingGuid!;
    this.urlParamsService.projectGuid$.subscribe((guid) => {
      if (guid) this.selectedProjectGuid = guid;
    });
    this.urlParamsService.commentGuid$.subscribe((guid) => {
      if (guid) this.selectedCommentGuid = guid;
    });
    this.urlParamsService.meetingGuid$.subscribe((guid) => {
      if (guid) this.meetingGuid = guid;
    });

    this.currentUrl = this.router.url;
    if (this.currentUrl.includes('/comment')) {
      this.subscribeSourceId = 1;
      this.subscriptionService.getProjectInfo(this.selectedProjectGuid).subscribe({
        next: (response: MinProjectDTO) => {
          this.projectInfo = response;
          this.isCommentActive = response.IsCommentActive ?? true;
          this.closedMessage = response.ClosedMessage ?? null;
          this.titleService.setTitle(`${this.projectInfo.ProjectName} - Comment Form`);
        },
        error: (error) => {
          console.error('Error fetching project info:', error);
        },
      });
    } else if (this.currentUrl.includes('/event-comment')) {
      this.subscribeSourceId = 2;
      this.commentService.getInPersonMeetingByGuid(this.meetingGuid).subscribe({
        next: (response: PublicMeetingDTO) => {
          this.projectInfo = this.filterToMinProjectDTO(response);
          this.titleService.setTitle(
            `${response.MeetingName} - Event Comment Form` // should we include the event name, project name, or both here?
          );
        },
        error: (error) => {
          console.error('Error fetching project info:', error);
        },
      });
    }
  }

  filterToMinProjectDTO(meeting: PublicMeetingDTO): MinProjectDTO {
    const { ProjectDescription, ProjectGuid, ProjectName, ProjectNumber, ProjectId, Settings } =
      meeting;
    return {
      ProjectDescription,
      ProjectGuid,
      ProjectName,
      ProjectNumber,
      ProjectId,
      Settings,
    };
  }

  handleFormSubmitted(success: boolean): void {
    this.isSubmitted = success;
    if (success) {
      setTimeout(() => this.gTranslateService.retranslate());
    }
  }

  resetForm(): void {
    this.isSubmitted = false;
  }
}
